import React, { Component } from 'react';

import Layout from '../components/Layout';
import Classes from './404.module.css';
import Sidebar from '../components/Sidebar';
import Menubar from '../components/Menubar';
import CardList from '../components/blogs/BlogsList/BlogsList';
import SearchStyle from '../components/blogs/SearchBox/SearchBox.module.css';
import SearchBox from '../components/blogs/SearchBox/SearchBox';
class downloads extends Component {
  state = {
    cardList: [
      {
        id: 'Madarij Assalekeen مدارج السالكين',
        title: 'Madarij Assalekeen مدارج السالكين ',
        link: 'https://myislam.net/static/Summary_Of_Madarej.pdf',
        image: 'https://myislam.net/static/madarij.png',
      },
      {
        id: 'The Best of Zikr',
        title: 'The Best of Zikr افضل الاذكار ',
        link: 'https://iloveallah.net/static/Zikr_table2.pdf',
        image: 'https://iloveallah.net/static/duaa.png',
      },
      {
        id: 'How to survive in the time of Crisis',
        title: 'How to survive in the time of Crisis - Download video',
        link: 'https://iloveallah.net/static/survive.mov',
        image:
          'https://rany.tk/static/How to survive in the time of Crisis.png',
      },
      {
        id: 'Intentions for Jamaa Arabic',
        title: 'Intentions for Jamaa Arabic',
        link: 'https://iloveallah.net/static/Intentions for Jamaa Arabic.pdf',
        image: 'https://iloveallah.net/static/intentionsforjamaa.png',
      },
      {
        id: 'Intentions for sunnah prayers Arabic نوايا لصلوات السنن',
        title: 'نوايا لصلوات السنن Intentions for sunnah prayers Arabic',
        link: 'https://iloveallah.net/static/intentionsforsunaharabic.pdf',
        image: 'https://iloveallah.net/static/intentionsforsunah.png',
      },
      {
        id: 'Ramadan and Our Hearts',
        title: 'Ramadan and Our Hearts',
        link: 'https://iloveallah.net/static/RamadanAndOurHearts.pdf',
        image: 'https://iloveallah.net/static/ramadanheart.png',
      },
    ],
    searchTerm: '',
  };
  render() {
    const { cardList, searchTerm } = this.state;
    const filteredList = cardList.filter(card =>
      card.title.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return (
      <Layout>
        <Sidebar showTabs="false" />
        <SearchBox
          placeHolder="Search for a document by a title"
          changeHandler={e =>
            this.setState({
              searchTerm: e.target.value,
            })
          }
        />
        <CardList list={filteredList} />
      </Layout>
    );
  }
}

export default downloads;
